export const VARIANTS = {
  DAY: 'day',
  WEEK: 'week',
  RANGE: 'range',
}

export const STATIC_WRAPPER_TYPE = 'desktop'

export const RANGE_DAY = {
  FIRST: 'first',
  LAST: 'last',
}

export const DATE_PICKER_TYPE = {
  REPORT: 'report',
}
